import styled from 'styled-components';
import HotelCompletedSvg from '../../assets/mytrips/hotel-completed.svg';

const HotelCompletedIcon = styled(HotelCompletedSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.5rem'};
  height: ${props => props.height || '2.5rem'};
  margin: ${props => props.margin};
`;

export default HotelCompletedIcon;
